export const blockList = ['gmil.com'];
